import { schemaCommon } from "common/bit/form/FormikSchema"
import * as yup from "yup"

export const regex = {
  singleName: /^[a-zA-Zא-ת'"\\.\-,\s]+$/,
  phoneNumber: /^05\d([-]{0,1})\d{7}$/,
}

const schemaContactUs = yup
  .object({
    subject: yup
      .string()
      .required("שדה חובה")
      .oneOf(["קניית רכב", "שירות"], "שדה חובה"),
    licenseNumber: yup
      .string()
      .nullable()
      .when("subject", {
        is: (val: string | undefined) => val === "שירות" || val === "",
        then: () => schemaCommon.licenseNumber.required("שדה חובה"),
        otherwise: (schema) => schema,
      }),
    model: yup.string().when("subject", {
      is: "קניית רכב",
      then: (schema) => schema.required("שדה חובה"),
      otherwise: (schema) => schema,
    }),
    showRoom: yup.string().when("subject", {
      is: "קניית רכב",
      then: (schema) => schema.required("שדה חובה"),
      otherwise: (schema) => schema,
    }),
    firstName: yup
      .string()
      .matches(regex.singleName, "יש להזין אותיות בעברית / אנגלית בלבד")
      .min(2, "יש להזין לפחות שתי אותיות תחת השם")
      .max(50, "יש להזין עד 50 תווים בלבד")
      .required("שדה זה הינו שדה חובה"),
    lastName: yup
      .string()
      .matches(regex.singleName, "יש להזין אותיות בעברית / אנגלית בלבד")
      .min(2, "יש להזין לפחות שתי אותיות תחת השם")
      .max(50, "יש להזין עד 50 תווים בלבד")
      .required("שדה זה הינו שדה חובה"),
    email: yup
      .string()
      .email("כתובת מייל אינה תקינה")
      .required("שדה זה הינו שדה חובה"),
    phoneNumber: yup
      .string()
      .matches(regex.phoneNumber, "טלפון אינו תקין")
      .required("שדה זה הינו שדה חובה")
      .max(10, "יש להזין עד 10 ספרות בלבד"),
    approveMailingList: yup.boolean().notRequired(),
    message: yup.string().max(500, "יש להזין עד 500 תווים בלבד"),
  })
  .defined()

export const initialFormStatesContactUs: yup.InferType<typeof schemaContactUs> =
  {
    subject: "קניית רכב",
    model: "",
    licenseNumber: "",
    showRoom: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
    approveMailingList: false,
  }

export default schemaContactUs
